export default __webpack_public_path__ + "static/media/homeActive.61774de3.svg";